import React from 'react';

import ImgUploadForm from 'views/ImgUploadForm';
import UserAPI from 'service/api/UserAPI';

const ProfilePicForm = ({user, readOnly}) => {

    const onUpload = function(uploadedImgFile) {
        if(readOnly === true){
            alert("You are not authorized to perform this action!");
            return;
        } 
        UserAPI.updateProfilePic(uploadedImgFile);
    };
    
    return <ImgUploadForm previewId="profilePicturePreview" className="profilePicForm" 
                        defaultPreviewImg={user.profilePicture} 
                        imgWidth="100px" imgHeight="100px" imgInfo="600 x 600, Less than 1Mb"
                        onUpload={onUpload} />
};
export default ProfilePicForm;


// WEBPACK FOOTER //
// ./src/views/user/ProfilePicForm.js